/**
 * @file ConsentConflictNotice.tsx
 * @description Конфликт редакций (phase19.16, Р3г; uiux-r3g-consent-texts §5
 * «Конфликт (409)»): пока сотрудник правил, вышла новая редакция. Правки уже
 * сохранены черновиком; [Сравнить] — отличия от вышедшей и публикация поверх
 * неё, [Начать заново от ред. N] — форма = вышедшая редакция.
 */

import type { ConsentConflict } from "../../../hooks/platform/useConsentTextsEditor";
import { formatConsentDateTime } from "../../../lib/platform/consent-texts-format";
import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";

interface Props {
  conflict: ConsentConflict;
  onCompare: () => void;
  onRestart: () => void;
  onReload: () => void;
}

export function ConsentConflictNotice({ conflict, onCompare, onRestart, onReload }: Props) {
  const { revision } = conflict;
  if (!revision) {
    return (
      <NoticeStrip tone="warning" action={<Button variant="outline" className="min-h-12" onClick={onReload}>Обновить</Button>}>
        Пока вы правили, вышла новая редакция. Ваши правки сохранены черновиком в этом браузере.
      </NoticeStrip>
    );
  }
  return (
    <NoticeStrip tone="warning">
      <p className="m-0">
        Пока вы правили, вышла редакция {revision.number} ({revision.publishedByName}, {formatConsentDateTime(revision.publishedAt)}).
        Ваши правки сохранены черновиком в этом браузере.
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        <Button variant="outline" className="min-h-12" onClick={onCompare}>
          Сравнить
        </Button>
        <Button variant="outline" className="min-h-12" onClick={onRestart}>
          Начать заново от ред. {revision.number}
        </Button>
      </div>
    </NoticeStrip>
  );
}
